import { Direction } from "../../detections/types";
import { PaymentInfo } from "../anpr-edges/types";

export type InfoDisplayPaymentInfoDb = PaymentInfo & {
  vehicleId: string;
  updatedAt: Date;
};

export type InfoDisplayContractRemainingSlotsDb = {
  id: number;
  companyId: number;
  availableSlots: number;
  allowOverparking: boolean;
  updatedAt: Date;
};

export type InfoDisplayContractSlotTargetsDb = {
  id: number;
  contractSlotId: number;
  hallId: string;
  laneId: string | null;
};

export type InfoDisplayContractVehiclesSinceSlotsSyncDb = {
  slotId: number;
  vehicleId: string;
  delta: number;
};

export type InfoDisplayCapacityDb = {
  hallId: string;
  maxCapacity: number;
  occupiedSpaces: number;
  updatedAt: Date;
};

export type InfoDisplayCapacityVehiclesSinceSyncDb = {
  hallId: string;
  vehicleId: string;
  delta: number;
};

export enum InfoDisplayMessageType {
  PlateEntranceOrExit = "plateEntranceOrExit",
  Capacity = "capacity",
  Settings = "settings",
}

export type InfoDisplayWsMessages = {
  [InfoDisplayMessageType.PlateEntranceOrExit]: {
    plateText: string;
    vehicleId: string;
    laneId: string;
    direction?: Direction | null;
    isOverparking: boolean;
    message: string;
    icon: "green-check" | "blue-warning";
  };
  [InfoDisplayMessageType.Settings]: {
    staticEntranceMessage: string;
    waitTimeMs: number;
    maxShowTimeMs: number;
    simultaneousPlates: number;
  };
  [InfoDisplayMessageType.Capacity]: {
    hallId: string;
    hallName: string;
    capacity: number | null;
  };
};

export type InfoDisplayMessages = {
  staticEntranceMessage: string;
  welcomeMessage: string;
  contractWelcomeMessage: string;
  byeMessage: string;
  parkingOperatedByMessage: string;
  parkingPaidMessage: string;
  parkingNotPaidMessage: string;
  overparkingMessage: string;
  freeParkingMessage: string;
};

export type WebSocketMessage<T extends InfoDisplayMessageType> = {
  type: T;
  payload: InfoDisplayWsMessages[T];
};
